import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { InformationSection } from './components/InformationSection';
import { PresentingSection } from './components/PresentingSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { AudienceSection } from './components/AudienceSection';
import { WhySection } from './components/WhySection';
import { NoMondaySection } from './components/NoMondaySection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { LastThingSection } from './components/LastThingSection';
export function App() {
  return <div className="min-h-screen w-full bg-ink font-sans text-bone" data-id="element-0" data-mp="28te1n9vnj3li">
      <OfferBar data-id="element-1" data-mp="23vkv2fqfs7kp" />
      <Hero data-id="element-2" data-mp="23w4g45bdvc2y" />
      <main data-id="element-3" data-mp="23u9q4cl98ts0">
        <ProblemSection data-id="element-4" data-mp="23utby4e102bb" />
        <InformationSection data-id="element-5" data-mp="23ti8y6semyl9" />
        <PresentingSection data-id="element-6" data-mp="3ikh8ubu2yx01" />
        <VolumesSection data-id="element-7" data-mp="3ij64oawq3n8e" />
        <BonusesSection data-id="element-8" data-mp="3ijpet5g4t7bv" />
        <PricingSection data-id="element-9" data-mp="3mlj82snzz920" />
        <AudienceSection data-id="element-10" data-mp="3mkre1ma1tjdu" />
        <WhySection data-id="element-11" data-mp="3mjzsz5e2v41t" />
        <NoMondaySection data-id="element-12" data-mp="3mjga9mglsbmq" />
        <FinalCtaSection data-id="element-13" data-mp="3rcj5s04xxv5k" />
        <LastThingSection data-id="element-14" data-mp="3rbzpsoyupgu6" />
      </main>
    </div>;
}